
import { FileX } from "lucide-react";

export const EmptyUsersList = () => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center rounded-md border border-dashed">
      <FileX className="h-12 w-12 text-muted-foreground mb-3" />
      <h3 className="text-lg font-semibold">No users found</h3>
      <p className="text-muted-foreground mt-1">
        No users match your search criteria or the database is empty.
      </p>
    </div>
  );
};
